// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"Breadcrumbs_Breadcrumbs__Edupv","delimeter":"Breadcrumbs_delimeter__16Mic","link":"Breadcrumbs_link__bFskk"};